import React from 'react';
import { Star, Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function UpsellSection() {
  return <section className="bg-white py-6 px-4" data-id="element-231">
      <div className="max-w-4xl mx-auto" data-id="element-232">
        <div className="border-4 border-yellow-400 rounded-2xl p-1 relative shadow-2xl overflow-hidden" data-id="element-233">
          {/* Badge */}
          <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-yellow-400 text-black font-black uppercase tracking-wider px-5 py-1.5 rounded-full shadow-lg z-10 flex items-center gap-2 whitespace-nowrap text-sm" data-id="element-234">
            <Star className="w-4 h-4 fill-black" data-id="element-235" /> MÁS POPULAR
          </div>

          <div className="bg-white rounded-xl p-4 md:p-6 pt-12 md:pt-14 text-center" data-id="element-236">
            <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-4 leading-tight" data-id="element-237">
              KIT COMPLETO PSICOLOGÍA{' '}
              <span className="text-gray-900" data-id="element-238">+ SISTEMA PRO DE EVALUACIÓN</span>
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-center mb-4" data-id="element-239">
              <a href="https://checkout.kitonline.shop/cart/47657882288366:1" className="block transform hover:scale-105 transition-transform duration-300" data-id="element-240">
                <img src="https://cdn.magicpatterns.com/uploads/t5BdPADdgeE8yTV15hNRCH/upsell_psicologia.png" alt="Super Kit Psicología + Sistema Pro" className="w-full rounded-lg shadow-lg" data-id="element-241" />
              </a>

              <div className="text-left mx-auto md:mx-0" data-id="element-242">
                <ul className="space-y-3 mb-4" data-id="element-243">
                  {['Kit completo Psicología', '100 consignas profesionales organizadas por unidad', 'Rúbricas de corrección', 'Modelos de evaluación', '3 Bonos incluidos', 'Garantía 7 días'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-244">
                      <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-245" />
                      <span className="font-medium text-gray-700" data-id="element-246">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>

            <div className="bg-gray-50 rounded-xl p-4 mb-4" data-id="element-247">
              <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 mb-2" data-id="element-248">
                <div className="text-gray-500 line-through text-2xl font-bold" data-id="element-249">
                  $34.990 ARS
                </div>
                <div className="text-4xl md:text-5xl font-extrabold text-green-600" data-id="element-250">
                  $24.990 ARS
                </div>
              </div>
              <div className="inline-block bg-green-100 text-green-800 font-bold px-4 py-1 rounded-full text-sm uppercase" data-id="element-251">
                Ahorrás $10.000 ARS
              </div>
            </div>

            <CTAButton href="https://checkout.kitonline.shop/cart/47657882288366:1" className="w-full md:w-auto px-8 py-5 text-xl" data-id="element-252">
              👉 SÍ, QUIERO EL SUPER MEGA PACK
            </CTAButton>
          </div>
        </div>
      </div>
    </section>;
}